<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication">
<p class="center">THIS BOOK IS DEDICATED<br/>TO<br/><span class="big2">ALEX. ERSKINE</span><br/>HYPNOLOGIST, PHILOSOPHER,<br/>AND FRIEND OF HUMANITY<br/>AND<br/>TO THOSE WHO HAVE GONE ON<br/>BEFORE</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?49bd5694